import React, { Fragment } from "react";
import Nav from "../../components/NavBar/Nav";
import Social from "../../components/SocialLinks/Social";
import Greeting from "../../components/Greeting/Greeting";
import Services from "../../components/Services/Services";
import Welcome from "../../components/Welcome/Welcome";
// import Projects from "../../components/Projects/Projects";
import Motivation from "../../components/Motivation/Motivation";
import Enhance from "../../components/Enhance/Enhance";
import Features from "../../components/Features/Features";
import Approach from "../../components/Approach/Approach";
import Benefits from "../../components/Benefits/Benefits";
import Footer from "../../components/Footer/Footer";
import Whats from "../../components/Whatsapp/Whats";

const index = () => {
  return (
    <Fragment>
      <Whats/>
      <Nav />
      <Social />
      <Greeting />
      <Services />
      <Welcome/>
      {/* <Projects/> */}
      <Motivation/>
      <Enhance/>
      <Features/>
      <Approach/>
      <Benefits/>
      <Footer/>
    </Fragment>
  );
};

export default index;
